<script>
	// Stores 
	import { 
		linkAV, 
		mailAtualize,
		textSite,

	} from '../store.js';

	// Componentes
	import { link } from "svelte-routing";

	import Forms from "../components/Forms.svelte";  
	import PageHeader from './../components/PageHeader.svelte';

	// Code
	let titlePage = 'Atualização Cadastral ';

	let fields = [
		{
			title:  'Nome *',
			name:   'nome',
			required:   'required'
		},
		{
			title:  'Telefone *',
			name:   'telefone',
			required: 'required',
			classe: 'mask-telefone',
		},
		{
			title:  'Email *',
			name:   'email',
			type:   'email',
			required: 'required',
		},
		{
			title:  'CPF *',
			name:   'cpf',
			required: 'required',
		},
		{
			title:  'RG *',
			name:   'rg',
			required: 'required',
		},
		{
			title:  'Condomínio *',
			name:   'condominio',
			required: 'required',
		},
		{
			title:  'Número da Unidade (Casa / Apartamento / Loja / Sala / etc) *',
			name:   'numero',
			required: 'required',
		},
		{
			title:  'Endereço *',
			name:   'endereco',
			required: 'required',
		},
	];
	const message = `
Nome: {nome}
Telefone: {telefone}
Email: {email}
CPF: {cpf}
RG: {rg}
Condomínio: {condominio}
Número da Unidade: {numero}
Endereço: {endereco}

{info}
	`;

	let loading = false;
	function send() {
		loading = true;
	}
</script>

<section class="conteudo-internas">
	<PageHeader title={titlePage} buttons="" ></PageHeader>
	<div class="container">
		<div class="row">             
			<div class="col-md-5 offset-md-1">       
				<Forms fields={fields} subject="Atualização Cadastral | {$textSite}" destiny={$mailAtualize} {message} htmlbody={false} />
				<hr>
			</div>
			<div class="col-md-5 d-md-block text-justify">
				<p>Utilize o botão abaixo para acessar a <a href="{$linkAV}" target="_blank"><b>Área do Cliente</b></a>.</p>

				<p>Caso não possua os dados de acesso, solicite ou faça sua atualização cadastral através do formulário.</p>
				
				<h3>Já atualizou seu cadastro e possui os dados de acesso?</h3>
				<p>Então acesse 2ª via de boletos, financeiro e mais aqui:</p>
				<p><a href="{$linkAV}" target="_blank" class="btn btn-primary"><i class="fas fa-user-circle"></i> Área do Cliente</a></p>

				<hr>

				<h3>Por que devo atualizar meus dados?</h3>
				<p>Conforme determinação da Circular 3.656/2013 emitida pelo <b>Banco Central do Brasil</b>, nenhum boleto poderá ser emitido sem o CPF do sacado (pagador). Visando tornar mais ágil, seguro e eficaz nossos processos, é de suma importância e urgência a atualização cadastral junto à administradora.</p>
				<p>Para usufruir os benefícios do site e do APP, e resolver os assuntos mais rapidamente, atualize seu cadastro através do formulário.</p>

				<hr>

				<h3>Precisa de ajuda?</h3>
				<p>Estamos prontos para auxiliar - <b><a href="/contato">entre em contato</a></b>.</p>

			</div>
		</div>
	</div>
</section>

<style type="text/sass">
@import 'public/assets/sass/variables.sass'
a
	color: $color-secondary
	&:hover
		color: $color-primary

</style>